export default function InstallBanner({ onInstall, onDismiss }) {
  return (
    <div className="install-banner fixed top-16 left-0 right-0 bg-indigo-600 text-white shadow-lg z-40 no-print">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a 3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            <div>
              <p className="font-medium">Install Sticker Maker Admin</p>
              <p className="text-sm text-indigo-100">Get the full desktop app experience!</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <button
              onClick={onInstall}
              className="px-4 py-2 bg-white text-indigo-600 rounded-lg font-medium hover:bg-indigo-50 transition-colors"
            >
              Install
            </button>
            <button
              onClick={onDismiss}
              className="px-4 py-2 text-white hover:text-indigo-100 transition-colors"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
